var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 201,
    viewBox: "0 0 240 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12110_35101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.2419 125.135C59.2419 125.135 78.4766 166.076 54.3704 170.596C30.2642 175.115 24.1071 147.986 24.1071 147.986L15.3887 153.611C15.3887 153.611 24.9106 184.929 51.4375 184.899C77.9644 184.868 95.9134 176.21 95.4012 147.986C94.8889 119.762 59.2419 125.135 59.2419 125.135Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M59.2419 125.135C59.2419 125.135 78.4766 166.076 54.3704 170.596C30.2642 175.115 24.1071 147.986 24.1071 147.986L15.3887 153.611C15.3887 153.611 24.9106 184.929 51.4375 184.899C77.9644 184.868 95.9134 176.21 95.4012 147.986C94.8889 119.762 59.2419 125.135 59.2419 125.135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7372 65.5117L80.0936 67.9123L68.6331 72.6833C68.6331 72.6833 44.6173 93.3142 53.3457 115.241C62.0742 137.167 101.428 157.718 101.428 157.718L116.996 137.449L87.7372 65.5117Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 0H87.3672V200.925H240V0Z",
    fill: "#E8ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M164.555 136.174C188.481 136.174 207.876 127.899 207.876 117.692C207.876 107.485 188.481 99.2109 164.555 99.2109C140.63 99.2109 121.234 107.485 121.234 117.692C121.234 127.899 140.63 136.174 164.555 136.174Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.952 30.6581C110.003 30.6581 112.476 28.1847 112.476 25.1337C112.476 22.0827 110.003 19.6094 106.952 19.6094C103.901 19.6094 101.428 22.0827 101.428 25.1337C101.428 28.1847 103.901 30.6581 106.952 30.6581Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.53 30.6581C125.581 30.6581 128.055 28.1847 128.055 25.1337C128.055 22.0827 125.581 19.6094 122.53 19.6094C119.479 19.6094 117.006 22.0827 117.006 25.1337C117.006 28.1847 119.479 30.6581 122.53 30.6581Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.436 30.6581C140.487 30.6581 142.961 28.1847 142.961 25.1337C142.961 22.0827 140.487 19.6094 137.436 19.6094C134.385 19.6094 131.912 22.0827 131.912 25.1337C131.912 28.1847 134.385 30.6581 137.436 30.6581Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.927 156.422H128.686C125.286 156.422 122.529 159.179 122.529 162.579V167.42C122.529 170.821 125.286 173.577 128.686 173.577H180.927C184.327 173.577 187.084 170.821 187.084 167.42V162.579C187.084 159.179 184.327 156.422 180.927 156.422Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.05 179.837C201.244 179.837 207.886 173.195 207.886 165.001C207.886 156.808 201.244 150.166 193.05 150.166C184.857 150.166 178.215 156.808 178.215 165.001C178.215 173.195 184.857 179.837 193.05 179.837Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.666 165.241L191.844 170.786L198.594 160.129",
    stroke: "white",
    strokeWidth: 3.045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2128 48.5264C57.2128 48.5264 58.7194 55.2159 61.2305 59.1934C61.4703 59.579 61.7841 59.9133 62.1538 60.1769C62.5236 60.4405 62.9419 60.6281 63.3847 60.729C63.8274 60.8299 64.2858 60.842 64.7332 60.7646C65.1807 60.6872 65.6083 60.5219 65.9915 60.2782C68.0003 59.0126 70.2904 56.7125 69.9188 53.0262L70.0494 46.6983C69.9445 45.428 69.4474 44.2218 68.6269 43.2464C67.8063 42.2711 66.7028 41.5749 65.4692 41.2544C60.9593 39.7879 56.0878 44.4986 57.2128 48.5264Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.989 47.8438L80.0935 67.9122L68.633 72.6832L65.8809 56.1704L69.989 47.8438Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.95 48.2858C60.9915 47.7241 62.9602 46.9251 64.8159 45.9053C64.5045 46.9861 64.5195 48.1348 64.8591 49.2071C65.1986 50.2794 65.8475 51.2274 66.7243 51.9319C67.5501 52.627 68.5921 53.0131 69.6715 53.0241C70.7509 53.0351 71.8005 52.6703 72.6403 51.9922L69.8279 43.6253C69.4721 42.4176 68.7957 41.3289 67.8708 40.4747C66.9459 39.6205 65.8069 39.0328 64.5748 38.7739C63.5055 38.5402 62.4216 38.3792 61.3305 38.2918C58.6085 38.0909 55.5852 40.833 52.9034 39.8989C52.6331 39.8041 52.3427 39.7814 52.061 39.8331C51.7792 39.8848 51.5158 40.009 51.2968 40.1936C51.0777 40.3782 50.9106 40.6167 50.8119 40.8856C50.7131 41.1545 50.6862 41.4445 50.7338 41.7269C51.1657 44.3987 52.9034 48.2658 56.7604 48.557C57.5005 48.596 58.2417 48.5042 58.95 48.2858Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9811 51.9126C65.9811 51.9126 65.2278 49.3815 67.1764 48.9697C69.125 48.5579 70.2399 52.214 67.779 53.3691L65.9811 51.9126Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3764 52.666L57.372 55.7596C57.3126 55.9354 57.2989 56.1234 57.3322 56.3059C57.3654 56.4885 57.4444 56.6596 57.5619 56.8031C57.6794 56.9467 57.8315 57.0581 58.0038 57.1268C58.1761 57.1956 58.3631 57.2193 58.5472 57.196L61.1888 56.8645L58.3764 52.666Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M66.332 59.8079C67.6837 58.9713 68.7595 57.7558 69.4256 56.3125C69.4256 56.3125 70.5104 60.3302 67.4168 65.513L66.332 59.8079Z",
    fill: "#CE8172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8904 148.768C22.8904 148.768 20.1684 138.875 15.3874 137.72C10.6063 136.565 17.0246 152.595 17.0246 152.595L22.8904 148.768Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1105 125.875L13.6094 128.789L18.358 145.901L28.8592 142.986L24.1105 125.875Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2324 76.6113V104.304H22.8076L19.4854 112.188L16.3447 104.304H0V76.6113H39.2324Z",
    fill: "#00AB50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7402 88.9061L18.7322 95.9471L26.2654 84.9688",
    stroke: "white",
    strokeWidth: 3.045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12110_35101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.645 59.7715H151.355C140.113 59.7715 131 68.8846 131 80.1262V107.417C131 118.658 140.113 127.771 151.355 127.771H178.645C189.887 127.771 199 118.658 199 107.417V80.1262C199 68.8846 189.887 59.7715 178.645 59.7715Z",
    fill: "#004E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.242 73.3633H154.836C161.672 73.3633 167.275 78.9574 167.275 85.8027V95.2865H154.682C147.845 95.2865 142.242 89.6924 142.242 82.847V73.3633Z",
    fill: "#00DD39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.93 101.425H183.07C181.32 101.425 179.879 99.9922 179.879 98.2332V91.7778H187.93V91.6962C187.93 87.3079 184.34 83.7266 179.96 83.7266H173.505V101.343H144.637V109.394H147.828C147.828 112.024 149.977 114.181 152.615 114.181C155.254 114.181 157.403 112.033 157.403 109.394H158.998C158.998 112.024 161.147 114.181 163.786 114.181C166.424 114.181 168.573 112.033 168.573 109.394H174.947C174.947 112.024 177.095 114.181 179.734 114.181C182.372 114.181 184.521 112.033 184.521 109.394H187.712V101.425H187.948H187.93Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12110_35101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 200.925,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12110_35101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white",
    transform: "translate(131 59.7715)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.08e5950448ec76863174676512408289.svg";
export { ForwardRef as ReactComponent };